module.exports = __webpack_public_path__ + "img/default-analyst-v3.09bfd13e.jpg";